angular.module('app').factory('skillGamesService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer) {
            Configurer.setBaseUrl(settings.apiURL);
        });

        var pages = restAngular.all("/page/");

        return {
            save: function (requestData) {
                return pages.
                one("saveSkillGames").
                post("", requestData)
            },
            load: function (requestOptions) {
                return pages.
                one("getSkillGames").
                customGET(param(requestOptions))
            }
        }
    }
]);
